module.exports = __webpack_public_path__ + "static/media/forever_tricolour_2.83c21aaa.jpg";